export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  date: string;
  author: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const latestAddress: Article[] = [
  {
    id: "art-101",
    title: "91.con 2026年8月最新官方入口地址汇总",
    slug: "latest-official-address-2026-08",
    excerpt: "本文汇总了91.con在2026年8月最新的官方入口地址，包括主域名和多个备用镜像地址，确保您随时可以稳定访问。",
    content: `<p>随着网络环境的不断变化，91.con 的访问地址可能会不定期更新。为了帮助广大用户顺利访问平台，本文汇总了截至 <strong>2026年8月</strong> 的最新官方入口地址。</p>
<h2>官方主域名</h2>
<p>请认准以下官方认证域名，谨防钓鱼网站：</p>
<ul>
<li><strong>https://www.91.con</strong> — 官方主站入口</li>
<li><strong>https://m.91.con</strong> — 移动端适配入口</li>
</ul>
<h2>备用镜像地址</h2>
<p>当主域名访问不稳定时，可尝试以下备用地址：</p>
<ul>
<li>备用地址一：通过官方公告获取最新镜像</li>
<li>备用地址二：关注官方社交媒体账号获取实时更新</li>
</ul>
<h2>温馨提示</h2>
<p>请将本页面添加到浏览器收藏夹，以便随时获取 91.con 最新地址更新。如遇到任何访问问题，欢迎查阅我们的 <a href="/category/access-guide">访问指引</a> 栏目。</p>
<h2>如何验证地址真伪</h2>
<p>始终通过本导航站或官方渠道获取地址，切勿点击来历不明的链接。官方地址的特征包括：</p>
<ul>
<li>使用 HTTPS 加密协议</li>
<li>域名拼写准确无误</li>
<li>页面底部有完整的备案信息</li>
</ul>`,
    categorySlug: "latest-address",
    categoryName: "最新地址",
    date: "2026-08-05",
    author: "91.con 导航团队",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20connection%20concept%20with%20warm%20amber%20and%20soft%20cream%20geometric%20abstract%20shapes%2C%20clean%20professional%20website%20background%20with%20subtle%20gradient%20texture%2C%20corporate%20technology%20aesthetic%20with%20warm%20lighting%2C%20no%20text%20no%20people%2C%20high%20quality%20editorial%20design&width=1200&height=630&seq=art-101-v1&orientation=landscape",
    tags: ["最新地址", "官方入口", "2026年8月"],
  },
  {
    id: "art-102",
    title: "91.con 备用访问地址获取方法全攻略",
    slug: "backup-address-guide",
    excerpt: "主域名无法访问时怎么办？本文详细介绍获取91.con备用访问地址的多种可靠方法，让您永不掉线。",
    content: `<p>当 91.con 主域名因网络波动或其他原因暂时无法访问时，您可以通过以下多种方法获取备用地址，确保访问不中断。</p>
<h2>方法一：收藏本导航站</h2>
<p>本页面（91.con官方入口导航）会实时更新所有可用地址，建议将本页加入浏览器书签，随时查看最新信息。</p>
<h2>方法二：关注官方社交媒体</h2>
<p>91.con 会在官方社交平台第一时间发布地址更新通知，关注后可及时接收推送。</p>
<h2>方法三：使用 DNS 优化</h2>
<p>有时候访问问题源于本地 DNS 解析，可以尝试更换公共 DNS 服务器（如 114.114.114.114 或 8.8.8.8）后再尝试访问。</p>
<h2>方法四：加入用户社群</h2>
<p>加入官方用户交流群，群内会及时分享最新的访问地址和技术支持。</p>`,
    categorySlug: "latest-address",
    categoryName: "最新地址",
    date: "2026-08-03",
    author: "91.con 导航团队",
    readTime: "4分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20network%20connection%20hub%20concept%2C%20multiple%20nodes%20connected%20in%20amber%20and%20cream%20gradient%2C%20soft%20geometric%20patterns%20on%20light%20background%2C%20clean%20modern%20tech%20aesthetic%2C%20editorial%20quality%20design%20without%20text&width=1200&height=630&seq=art-102-v1&orientation=landscape",
    tags: ["备用地址", "访问方法", "DNS优化"],
  },
  {
    id: "art-103",
    title: "如何判断91.con访问地址是否为官方正版渠道",
    slug: "verify-official-address",
    excerpt: "网络上的91.con地址真假难辨，本文教您通过多种方式验证地址真伪，保护账号安全。",
    content: `<p>近期我们收到大量用户反馈，称在搜索引擎或社交媒体上看到了大量冒充 91.con 的虚假网站。本文为大家提供一套完整的地址验证方法。</p>
<h2>官方地址的核心特征</h2>
<ul>
<li><strong>HTTPS加密：</strong>所有官方渠道均使用 HTTPS 协议，浏览器地址栏会显示安全锁图标。</li>
<li><strong>域名准确性：</strong>官方域名拼写规范，不存在多余字符或拼写错误。</li>
<li><strong>页面完整性：</strong>官方页面设计专业，功能齐全，不会出现大量弹窗广告。</li>
</ul>
<h2>验证三步法</h2>
<ol>
<li>通过本导航站获取地址，本页所有地址均经过人工验证</li>
<li>访问后在页面底部查看网站备案信息</li>
<li>对比官方社交媒体发布的地址，确保一致</li>
</ol>`,
    categorySlug: "latest-address",
    categoryName: "最新地址",
    date: "2026-08-01",
    author: "91.con 安全团队",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20shield%20and%20checkmark%20concept%20in%20warm%20amber%20and%20cream%20tones%2C%20verification%20security%20abstract%20design%2C%20soft%20geometric%20background%20with%20subtle%20gradients%2C%20professional%20corporate%20aesthetic%2C%20high%20quality%20editorial&width=1200&height=630&seq=art-103-v1&orientation=landscape",
    tags: ["地址验证", "防钓鱼", "官方渠道"],
  },
];

export const accessGuides: Article[] = [
  {
    id: "art-201",
    title: "Windows/Mac 电脑端访问 91.con 完整操作指南",
    slug: "desktop-access-guide",
    excerpt: "详细图文教程，指导您在 Windows 和 Mac 电脑上使用不同浏览器安全访问 91.con。",
    content: `<p>本文面向电脑端用户，详细介绍在 Windows 和 Mac 操作系统下，通过主流浏览器安全访问 91.con 的完整步骤。</p>
<h2>Windows 用户操作步骤</h2>
<ol>
<li>打开您常用的浏览器（推荐 Chrome、Edge 或 Firefox）</li>
<li>在地址栏输入 91.con 官方地址</li>
<li>确认页面加载后地址栏显示安全锁图标</li>
<li>如遇无法访问，请尝试备用地址或参阅我们的 <a href="/category/safety-tips">安全须知</a></li>
</ol>
<h2>Mac 用户操作步骤</h2>
<ol>
<li>打开 Safari 或 Chrome 浏览器</li>
<li>输入官方地址并回车</li>
<li>如有安全提示，确认后继续访问</li>
</ol>
<h2>浏览器推荐设置</h2>
<p>建议在浏览器中启用以下设置以获得最佳体验：</p>
<ul>
<li>开启 JavaScript</li>
<li>允许 Cookie</li>
<li>使用最新版本浏览器</li>
</ul>`,
    categorySlug: "access-guide",
    categoryName: "访问指引",
    date: "2026-08-04",
    author: "91.con 技术团队",
    readTime: "7分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20laptop%20and%20desktop%20setup%20illustration%20in%20warm%20amber%20cream%20tones%2C%20clean%20workspace%20with%20soft%20geometric%20elements%2C%20professional%20tech%20aesthetic%2C%20abstract%20background%20with%20gentle%20gradients%2C%20editorial%20quality&width=1200&height=630&seq=art-201-v1&orientation=landscape",
    tags: ["电脑端", "浏览器", "操作指南"],
  },
  {
    id: "art-202",
    title: "iOS/Android 手机端访问 91.con 移动版教程",
    slug: "mobile-access-guide",
    excerpt: "手把手教您在 iPhone 和 Android 手机上访问 91.con 移动版，享受流畅的手机端体验。",
    content: `<p>越来越多用户选择在手机上访问 91.con，本文为您详细介绍 iOS 和 Android 设备的访问方法。</p>
<h2>iOS (iPhone/iPad) 用户</h2>
<ol>
<li>打开 Safari 浏览器</li>
<li>在地址栏输入 91.con 移动版地址</li>
<li>建议将页面添加到主屏幕，方便日后快速访问</li>
</ol>
<h2>Android 用户</h2>
<ol>
<li>打开 Chrome 或其他浏览器</li>
<li>输入移动版地址</li>
<li>可通过浏览器菜单"添加到主屏幕"创建快捷方式</li>
</ol>
<h2>移动端优化体验</h2>
<p>91.con 移动版针对小屏幕进行了全面优化，操作流畅、加载迅速。建议使用 Wi-Fi 或稳定的移动网络访问以获得最佳体验。</p>`,
    categorySlug: "access-guide",
    categoryName: "访问指引",
    date: "2026-08-02",
    author: "91.con 技术团队",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20with%20clean%20mobile%20interface%20in%20warm%20amber%20cream%20color%20scheme%2C%20minimalist%20flat%20design%20illustration%2C%20soft%20geometric%20abstract%20background%2C%20modern%20tech%20aesthetic%2C%20editorial%20quality%20without%20text&width=1200&height=630&seq=art-202-v1&orientation=landscape",
    tags: ["手机端", "iOS", "Android"],
  },
];

export const safetyTips: Article[] = [
  {
    id: "art-301",
    title: "谨防钓鱼网站：如何识别假冒 91.con 的虚假页面",
    slug: "identify-phishing-sites",
    excerpt: "近期假冒91.con的钓鱼网站增多，本文教您快速识别虚假页面，保护账号和隐私安全。",
    content: `<p>随着 91.con 用户群体的不断扩大，一些不法分子开始制作假冒的钓鱼网站，试图窃取用户账号和密码。本文帮助您练就一双火眼金睛。</p>
<h2>钓鱼网站的常见特征</h2>
<ul>
<li><strong>域名异常：</strong>域名拼写与官方接近但有细微差异，如多一个字母、使用相似字符替代等</li>
<li><strong>缺少HTTPS：</strong>地址栏没有安全锁图标，或证书信息异常</li>
<li><strong>页面粗糙：</strong>设计简陋、图片模糊、功能不完整</li>
<li><strong>诱导输入：</strong>频繁弹出登录窗口，要求输入敏感信息</li>
</ul>
<h2>防范措施</h2>
<ol>
<li>仅通过本导航站或官方渠道获取访问地址</li>
<li>开启浏览器的安全浏览功能</li>
<li>定期修改密码，使用强密码组合</li>
<li>不要在多个平台使用相同密码</li>
</ol>
<h2>发现钓鱼网站怎么办</h2>
<p>如果您发现了疑似钓鱼网站，请立即向我们举报，我们将及时核实并提醒其他用户。</p>`,
    categorySlug: "safety-tips",
    categoryName: "安全须知",
    date: "2026-08-04",
    author: "91.con 安全团队",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Alert%20warning%20concept%20in%20warm%20amber%20and%20cream%20minimalist%20design%2C%20shield%20and%20exclamation%20abstract%20geometric%20shapes%2C%20security%20awareness%20theme%20with%20soft%20gradients%2C%20clean%20professional%20editorial%20style&width=1200&height=630&seq=art-301-v1&orientation=landscape",
    tags: ["钓鱼网站", "安全防护", "账号保护"],
  },
  {
    id: "art-302",
    title: "91.con 账号安全防护最佳实践指南",
    slug: "account-security-best-practices",
    excerpt: "从密码管理到二次验证，全面介绍保护91.con账号安全的最佳实践方法。",
    content: `<p>账号安全是每位用户最关心的问题。本文整理了保护 91.con 账号安全的全面指南。</p>
<h2>强密码设置</h2>
<ul>
<li>密码长度至少 12 位</li>
<li>包含大小写字母、数字和特殊符号</li>
<li>避免使用生日、手机号等个人信息</li>
<li>每 3 个月更换一次密码</li>
</ul>
<h2>设备安全</h2>
<ul>
<li>不要在公共电脑上保存登录状态</li>
<li>定期查杀病毒和木马</li>
<li>保持操作系统和浏览器最新版本</li>
</ul>
<h2>网络环境安全</h2>
<ul>
<li>避免在公共 Wi-Fi 下登录账号</li>
<li>使用 VPN 增加网络安全性</li>
<li>开启路由器防火墙</li>
</ul>`,
    categorySlug: "safety-tips",
    categoryName: "安全须知",
    date: "2026-08-01",
    author: "91.con 安全团队",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Lock%20and%20key%20security%20concept%20in%20warm%20amber%20cream%20minimalist%20style%2C%20abstract%20geometric%20shapes%20with%20protection%20theme%2C%20soft%20gradient%20background%2C%20clean%20professional%20editorial%20design&width=1200&height=630&seq=art-302-v1&orientation=landscape",
    tags: ["账号安全", "密码管理", "安全防护"],
  },
];

export const faqArticles: Article[] = [
  {
    id: "art-401",
    title: "91.con 打不开了怎么办？常见原因及解决方法汇总",
    slug: "cannot-access-solutions",
    excerpt: "遇到91.con无法访问的情况不用慌，本文汇总了所有可能原因及对应的解决方案。",
    content: `<p>如果您遇到 91.con 无法访问的情况，请不要着急。本文整理了所有可能的原因和最有效的解决方案。</p>
<h2>可能原因及解决方案</h2>
<h3>1. 网络问题</h3>
<p>尝试切换网络环境（如从 Wi-Fi 切换到移动数据），或重启路由器。</p>
<h3>2. DNS 解析问题</h3>
<p>尝试修改 DNS 设置为公共 DNS（如 114.114.114.114），然后刷新 DNS 缓存。</p>
<h3>3. 浏览器缓存问题</h3>
<p>清除浏览器缓存和 Cookie，或尝试使用无痕模式访问。</p>
<h3>4. 地址已更新</h3>
<p>访问地址可能已更新，请在本导航站获取最新地址。</p>
<h3>5. 防火墙或安全软件拦截</h3>
<p>检查防火墙和安全软件设置，将 91.con 添加到信任列表。</p>
<h2>终极解决方案</h2>
<p>如果以上方法均无效，请收藏本页面并定期查看更新，我们会持续跟踪并发布最新的访问方法。</p>`,
    categorySlug: "faq",
    categoryName: "常见问题",
    date: "2026-08-05",
    author: "91.con 客服团队",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Help%20and%20solution%20concept%20in%20warm%20amber%20cream%20minimalist%20style%2C%20question%20mark%20and%20checkmark%20abstract%20geometric%20design%2C%20soft%20gradient%20background%2C%20clean%20professional%20editorial&width=1200&height=630&seq=art-401-v1&orientation=landscape",
    tags: ["无法访问", "故障排除", "常见问题"],
  },
  {
    id: "art-402",
    title: "91.con 账号被冻结或异常登录怎么办？",
    slug: "account-frozen-help",
    excerpt: "账号出现异常时的正确处理方法，包括联系客服、申诉流程及预防措施。",
    content: `<p>如果您的 91.con 账号出现被冻结或异常登录提醒，请按照以下流程处理。</p>
<h2>账号被冻结的处理步骤</h2>
<ol>
<li>确认冻结原因：登录时查看系统提示的具体原因</li>
<li>联系官方客服：通过官方渠道提交申诉</li>
<li>提供验证信息：按要求提供身份验证材料</li>
<li>等待审核：通常需要 1-3 个工作日</li>
</ol>
<h2>异常登录的处理</h2>
<ul>
<li>立即修改密码</li>
<li>检查登录设备记录</li>
<li>开启登录通知功能</li>
<li>联系客服确认账号状态</li>
</ul>
<h2>预防措施</h2>
<p>定期检查账号安全设置，避免使用简单密码，不要与他人共享账号。</p>`,
    categorySlug: "faq",
    categoryName: "常见问题",
    date: "2026-07-30",
    author: "91.con 客服团队",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Account%20recovery%20and%20support%20concept%20in%20warm%20amber%20cream%20minimalist%20design%2C%20abstract%20key%20and%20user%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20clean%20professional%20editorial%20style&width=1200&height=630&seq=art-402-v1&orientation=landscape",
    tags: ["账号冻结", "异常登录", "客服"],
  },
];

export const tutorials: Article[] = [
  {
    id: "art-501",
    title: "91.con 新用户注册与入门完整图文教程",
    slug: "new-user-registration-guide",
    excerpt: "面向首次使用91.con的新用户，从注册到基础功能使用的完整图文教程。",
    content: `<p>欢迎加入 91.con！本文为新用户提供从零开始的完整入门指南。</p>
<h2>第一步：获取官方地址</h2>
<p>通过本导航站获取 91.con 最新官方入口地址。</p>
<h2>第二步：注册账号</h2>
<ol>
<li>访问官方地址后，点击页面上的"注册"按钮</li>
<li>填写必要的注册信息</li>
<li>验证手机号或邮箱</li>
<li>设置安全密码</li>
<li>完成注册并登录</li>
</ol>
<h2>第三步：完善个人信息</h2>
<p>登录后建议完善个人资料，包括头像、昵称等基础设置。</p>
<h2>第四步：开始使用</h2>
<p>浏览平台各项功能，熟悉操作界面。如有疑问可查阅其他教程或联系客服。</p>`,
    categorySlug: "tutorials",
    categoryName: "使用教程",
    date: "2026-08-03",
    author: "91.con 教程团队",
    readTime: "10分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Beginner%20guide%20concept%20in%20warm%20amber%20cream%20minimalist%20design%2C%20abstract%20person%20and%20document%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20clean%20professional%20editorial%20style&width=1200&height=630&seq=art-501-v1&orientation=landscape",
    tags: ["新用户", "注册教程", "入门指南"],
  },
];

export const allArticles: Article[] = [
  ...latestAddress,
  ...accessGuides,
  ...safetyTips,
  ...faqArticles,
  ...tutorials,
];

export function getArticlesByCategory(slug: string): Article[] {
  return allArticles.filter((a) => a.categorySlug === slug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return allArticles.find((a) => a.slug === slug);
}

export function getRelatedArticles(article: Article, limit: number = 3): Article[] {
  return allArticles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, limit);
}